import WordsAudioContainer from './WordsAudioContainer';

export default WordsAudioContainer;
